import Vue from 'vue'
import Vuex from 'vuex'

import addresses from './data/addresses'
import app from './app'
import appDialogs from './components/appDialogs'
import appLayout from './appLayout'
import appNotificationBar from './appNotificationBar'
import appPrintQueue from './components/appPrintQueue'
import appSyncNotifications from './data/appSyncNotifications'
import appToast from './components/appToast'
import auth from './data/auth'
import autoresponders from './views/autoresponders'
import brand from './data/brand'
import broadcasts from './data/broadcasts'
import broadcastsView from './views/broadcasts-view'
import campaigns from './data/campaigns'
import channels from './data/channels'
import chatbots from './data/chatbots'
import chatbotsView from './views/chatbots-view'
import consent from './data/consent'
import contacts from './views/contacts'
import csvImport from './components/import'
import customFields from './views/custom-fields'
import device from './device'
import errors from './data/errors'
import extensionOptions from './data/extensionOptions'
import forms from './data/forms'
import formsView from './views/forms-view'
import formSubmissions from './data/formSubmissions'
import groups from './data/groups'
import helpModal from './helpModal'
import iLists from './components/ILists'
import inbox from './views/inbox'
import inputs from './components/inputs'
import integrations from './data/integrations'
import invitations from './data/invitations'
import invoices from './data/invoices'
import invoiceCampaigns from './data/invoiceCampaigns'
import lists from './views/lists'
import media from './data/media'
import mediaView from './views/media-view'
import messages from './data/messages'
import messagesTable from './components/messagesTable'
import messageTextForm from './components/messageTextForm'
import notificationList from './components/notificationList'
import notificationPopup from './components/notificationPopup'
import notificationsView from './views/notifications-view'
import officeHours from './data/officeHours'
import payments from './views/payments'
import person from './data/person'
import persons from './data/persons'
import personsAutocomplete from './components/personsAutocomplete'
import personsMerge from './views/persons-merge'
import personsQueue from './components/personsQueue'
import phoneNumbers from './data/phoneNumbers'
import phoneOrders from './data/phoneOrders'
import provinces from './data/provinces'
import qbo from './data/qbo'
import recaptcha from './components/recaptcha'
import roles from './data/roles'
import routes from './data/routes'
import routesView from './views/routes-view'
import schedules from './data/schedules'
import searchBar from './components/searchBar'
import settings from './data/settings'
import smsAccounts from './data/smsAccounts'
import splashScreen from './components/splash-screen'
import states from './data/states'
import stocks from './data/stocks'
import stripe from './data/stripe'
import subscriptions from './data/subscriptions'
import teammates from './views/teammates'
import templates from './data/templates'
import templatesView from './views/templates-view'
import tenant from './data/tenant'
import tenantMemberships from './data/tenantMemberships'
import triPanel from './components/triPanel'
import users from './data/users'
import xero from './data/xero'

Vue.use(Vuex)

export const store = new Vuex.Store({
    modules: {
        addresses,
        app,
        appDialogs,
        appLayout,
        appNotificationBar,
        appPrintQueue,
        appSyncNotifications,
        appToast,
        auth,
        autoresponders,
        brand,
        broadcasts,
        broadcastsView,
        campaigns,
        channels,
        chatbots,
        chatbotsView,
        consent,
        contacts,
        csvImport,
        customFields,
        device,
        errors,
        extensionOptions,
        forms,
        formsView,
        formSubmissions,
        groups,
        helpModal,
        iLists,
        inbox,
        inputs,
        integrations,
        invitations,
        invoices,
        invoiceCampaigns,
        lists,
        media,
        mediaView,
        messages,
        messagesTable,
        messageTextForm,
        notificationList,
        notificationPopup,
        notificationsView,
        officeHours,
        payments,
        person,
        persons,
        personsAutocomplete,
        personsMerge,
        personsQueue,
        phoneNumbers,
        phoneOrders,
        provinces,
        qbo,
        recaptcha,
        roles,
        routes,
        routesView,
        schedules,
        searchBar,
        settings,
        smsAccounts,
        splashScreen,
        states,
        stocks,
        stripe,
        subscriptions,
        teammates,
        templates,
        templatesView,
        tenant,
        tenantMemberships,
        triPanel,
        users,
        xero
    }
})
